import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`
export default {
    summary: {
        url: `${customerApi}/api/mass_sending/{id}/summary`,
        type: 'GET',
    },
    // 群发列表
    getList: {
        url: `${customerApi}/api/mass_sending/{id}/user_details`,
        type: 'GET',
    },
    exportData: {
        url: `${customerApi}/api/mass_sending/{id}/user_details/export`,
        type: 'POST',
    },
}
